<template>
	<div class="bool-filter">
		<div class="bool-filter__options">
			<FormKit
				type="checkbox"
				outer-class="bool-filter-option"
				:label="resolvedYesLabel"
				v-model="yes"
				@input="onYesInput"
			/>
			<FormKit
				type="checkbox"
				outer-class="bool-filter-option"
				:label="resolvedNoLabel"
				v-model="no"
				@input="onNoInput"
			/>
		</div>
	</div>
</template>

<script src="./FormulateBoolFilter.js"></script>
